import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F0] via-[#FFE8F0] to-[#F5E8FF]">
      <div className="max-w-[600px] mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img
              src="https://static.readdy.ai/image/2ded901b8fb990e993c5117b32e5999e/f6b52d0828689e13d597e866faced30e.png"
              alt="ERAI Logo"
              className="w-16 h-16 rounded-full object-cover"
            />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">プライバシーポリシー</h1>
          <p className="text-sm text-gray-500 mt-1">最終更新日：2025年1月</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-4">
          <div className="space-y-6">
            {/* Introduction */}
            <section>
              <p className="text-sm text-gray-600 leading-relaxed">
                ERAI（えらい）（以下「本アプリ」）は、ユーザーの皆様のプライバシーを尊重し、個人情報の保護に努めています。本プライバシーポリシーでは、本アプリがどのような情報を収集し、どのように利用するかについて説明します。
              </p>
            </section>

            {/* App Overview */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                アプリ概要
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                ERAIは、AIがユーザーを肯定する通知を届ける応援アプリです。ユーザーは気分や心の状態をチェックイン形式で記録できます。有料プラン（ERAI Plus）では通知最適化や履歴閲覧機能をご利用いただけます。
              </p>
            </section>

            {/* 1. Collected Information */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                1. 収集する情報
              </h2>
              <div className="space-y-3 text-sm text-gray-600 leading-relaxed">
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">気分チェックインデータ</h3>
                  <p>
                    ユーザーが記録した気分や心の状態に関するデータを収集します。これらはヘルスケア・フィットネス関連データに分類されます。
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">アプリ利用状況データ</h3>
                  <p>
                    アプリの使用頻度、機能の利用状況など、アプリの改善に必要な情報を収集します。
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">識別子</h3>
                  <p>
                    ユーザーID、RevenueCat匿名IDなど、サービス提供に必要な識別情報を収集します。
                  </p>
                </div>
              </div>
            </section>

            {/* 2. Purpose of Use */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                2. データの利用目的
              </h2>
              <ul className="space-y-2 text-sm text-gray-600 leading-relaxed">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>通知の最適化：ユーザーの気分に合わせた適切なタイミングでの通知配信</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>アプリ機能の改善：より良いユーザー体験の提供</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>サブスクリプション管理：有料プランの提供と管理</span>
                </li>
              </ul>
            </section>

            {/* 3. Data Linking */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                3. データとユーザーの紐付け
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                気分記録データはユーザーアカウントに紐づけられ、履歴閲覧機能などで利用されます。ユーザーはいつでもデータの削除を要求できます。
              </p>
            </section>

            {/* 4. Tracking */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                4. トラッキングについて
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                本アプリは広告目的のトラッキングを一切行いません。そのため、App Tracking Transparency（ATT）の許可は不要です。
              </p>
            </section>

            {/* 5. Data Storage */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                5. データ保存
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                ユーザーデータは安全に管理され、不正アクセスや漏洩を防ぐための適切なセキュリティ対策を講じています。
              </p>
            </section>

            {/* 6. Third Party Sharing */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                6. 第三者共有
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                決済処理のために、RevenueCatおよびAppleと必要最小限のデータを共有します。これらの第三者は、それぞれのプライバシーポリシーに従ってデータを取り扱います。
              </p>
            </section>

            {/* 7. Medical Disclaimer */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                7. 医療免責
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                本アプリは医療サービスではありません。医療的なアドバイスや診断、治療を提供するものではありません。健康上の問題がある場合は、必ず医療専門家にご相談ください。
              </p>
            </section>

            {/* 8. Contact */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                8. お問い合わせ
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-2">
                本プライバシーポリシーに関するご質問やご不明な点がございましたら、以下までお問い合わせください。
              </p>
              <a
                href="mailto:poznan9320@gmail.com"
                className="text-sm text-[#5B9BD5] font-medium hover:underline"
              >
                poznan9320@gmail.com
              </a>
            </section>
          </div>
        </div>

        {/* Back Button */}
        <div className="mb-4">
          <Link
            to="/support"
            className="flex items-center justify-center bg-white rounded-2xl shadow-sm p-4 hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg text-gray-600 mr-2" />
            <span className="text-sm font-medium text-gray-700">サポートページに戻る</span>
          </Link>
        </div>

        {/* Footer */}
        <div className="text-center py-6">
          <p className="text-xs text-gray-400">© 2025 ERAI</p>
          <p className="text-xs text-gray-400 mt-1">Made with 💙</p>
        </div>
      </div>
    </div>
  );
}